import { Helmet } from 'react-helmet';

export default function About() {
    return (
        <>
            <Helmet>
                <title>About | A. Page Code</title>
                <meta name="description" content="Basic example" />
            </Helmet>
            <h1>We have been doing stuff for quite a while...</h1>
        </>
    );
}